"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20Grid = void 0;
const TSBlock_1 = require("./TSBlock");
class Z20Grid {
    constructor(sx, sy, size, dist) {
        this._sx = sx;
        this._sy = sy;
        this._dist = dist;
        this._size = size;
        this._grid = [];
        for (let x = 0; x < this._size.x; x++) {
            this._grid.push([]);
            for (let y = 0; y < this._size.y; y++) {
                this._grid[x].push([]);
            }
        }
    }
    at(x, y) {
        if (!this.validBounds(x, y))
            return [];
        return this._grid[x][y];
    }
    allPieces() {
        const pieces = [];
        for (let y = 0; y < this._size.y; y++) {
            for (let x = 0; x < this._size.x; x++) {
                pieces.push(...this._grid[x][y]);
            }
        }
        return pieces;
    }
    remove(block) {
        if (!block.pos) {
            console.warn("Block wasn't in grid");
        }
        const arr = this._grid[block.pos.x][block.pos.y];
        if (arr.includes(block)) {
            const idx = arr.indexOf(block);
            arr.splice(idx, 1);
        }
    }
    forceAddAt(block, x, y) {
        this.relocate(block, x, y);
        return true;
    }
    forceMoveTo(block, x, y) {
        if (!this.validBounds(x, y)) {
            console.error("Block outside of bounds", x, y);
            return false;
        }
        this.relocate(block, x, y);
        return true;
    }
    tryMoveTo(block, dir) {
        const offset = TSBlock_1.TSBlockMoving.OffsetForDir(dir);
        const x = block.pos.x + offset[0];
        const y = block.pos.y + offset[1];
        if (!this.validBounds(x, y)) {
            // console.error("Block outside of bounds", x, y)
            return false;
        }
        const arr = this._grid[x][y];
        const toKill = [];
        let requiresMove = true;
        for (let i = 0; i < arr.length; i++) {
            const targetAttr = arr[i].attr;
            if (targetAttr == TSBlock_1.TSBlockAttribute.Blocks)
                return false;
            else if (targetAttr == TSBlock_1.TSBlockAttribute.PushableSanitize && !this.tryMoveTo(arr[i], dir))
                return false;
            else if (targetAttr == TSBlock_1.TSBlockAttribute.Icy) {
                requiresMove = false;
                this.relocate(block, x, y);
                this.tryMoveTo(block, dir);
                return true;
            }
        }
        for (const btk of toKill) {
            btk.kill();
        }
        if (requiresMove)
            this.relocate(block, x, y);
        return true;
    }
    swapWith(block, x, y) {
        if (!this.validBounds(x, y)) {
            console.error("Block outside of bounds", x, y);
            return;
        }
        if (this._grid[x][y].length > 0) {
            this.relocate(this._grid[x][y][0], block.pos.x, block.pos.y, true);
        }
        this.relocate(block, x, y);
    }
    relocate(block, x, y, addToBottom = false) {
        if (!this.validBounds(x, y)) {
            console.error("Block outside of bounds", x, y);
            return;
        }
        this.remove(block);
        if (addToBottom)
            this._grid[x][y].unshift(block);
        else
            this._grid[x][y].push(block);
        block.pos = new Phaser.Math.Vector2(x, y);
        block.setPosition(this._sx + x * this._dist, this._sy + y * this._dist);
    }
    validBounds(x, y) {
        if (x < 0 || y < 0 || x > this._size.x - 1 || y > this._size.y - 1)
            return false;
        return true;
    }
}
exports.Z20Grid = Z20Grid;
